import { useLocation } from "react-router-dom";
import UserSettings from "./UserSettings";

const useExportFieldOrder = (keyname) => {
    const { pathname } = useLocation();
    const [updateSettings] = UserSettings();
    const storageKey = `${pathname}_${keyname}`;

    const getSavedOrder = () => {
        const settings = JSON.parse(localStorage.getItem("loggedUserSettings")) || {};
        return (settings.exportFieldOrder && settings.exportFieldOrder[storageKey]) || null;
    };

    const saveOrder = (order) => {
        const settings = JSON.parse(localStorage.getItem("loggedUserSettings")) || {};
        const updated = { ...settings, exportFieldOrder: { ...settings.exportFieldOrder, [storageKey]: order } };
        localStorage.setItem("loggedUserSettings", JSON.stringify(updated));
        updateSettings(updated);
    };

    return { getSavedOrder, saveOrder };
};

export default useExportFieldOrder;
